module.exports = __webpack_public_path__ + "img/flourish research.05d8dc9d.png";